var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        id: "Capa_1",
        "enable-background": "new 0 0 512 512",
        height: "512",
        viewBox: "0 0 512 512",
        width: "512",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { id: "XMLID_2582_" } }, [
        _c("g", { attrs: { id: "XMLID_1302_" } }, [
          _c("path", {
            attrs: {
              id: "XMLID_1308_",
              d: "m482 60h-25.318c-4.646-22.795-24.847-40-48.994-40s-44.348 17.205-48.994 40h-53.701c-4.645-22.795-24.847-40-48.993-40s-44.348 17.205-48.994 40h-54.012c-4.646-22.795-24.848-40-48.994-40s-44.348 17.205-48.994 40h-25.006c-16.542 0-30 13.458-30 30v372c0 16.542 13.458 30 30 30h181c5.523 0 10-4.477 10-10s-4.477-10-10-10h-181c-5.514 0-10-4.486-10-10v-293.917h472v293.917c0 5.514-4.486 10-10 10h-181c-5.523 0-10 4.477-10 10s4.477 10 10 10h181c16.542 0 30-13.458 30-30v-372c0-16.542-13.458-30-30-30zm-74.312-20c13.036 0 24.152 8.361 28.28 20h-56.56c4.129-11.639 15.244-20 28.28-20zm-151.688 0c13.036 0 24.152 8.361 28.28 20h-56.56c4.128-11.639 15.244-20 28.28-20zm-152 0c13.036 0 24.152 8.361 28.28 20h-56.56c4.128-11.639 15.244-20 28.28-20zm-84 108.083v-58.083c0-5.514 4.486-10 10-10h25.006c4.646 22.795 24.847 40 48.994 40 5.523 0 10-4.477 10-10s-4.477-10-10-10c-13.036 0-24.152-8.361-28.28-20h131.286c4.646 22.795 24.847 40 48.994 40 5.523 0 10-4.477 10-10s-4.477-10-10-10c-13.036 0-24.152-8.361-28.28-20h130.974c4.646 22.795 24.847 40 48.994 40 5.523 0 10-4.477 10-10s-4.477-10-10-10c-13.036 0-24.152-8.361-28.28-20h102.592c5.514 0 10 4.486 10 10v58.083z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "XMLID_1317_",
              d: "m182.943 226.042c5.523 0 10-4.477 10-10s-4.477-10-10-10h-32.424c-5.523 0-10 4.477-10 10v80c0 5.523 4.477 10 10 10s10-4.477 10-10v-30.757h19.849c5.523 0 10-4.477 10-10s-4.477-10-10-10h-19.849v-19.243z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "XMLID_1318_",
              d: "m274.651 296.042c0-5.523-4.477-10-10-10h-23.708v-20h21.223c5.523 0 10-4.477 10-10s-4.477-10-10-10h-21.223v-20h23.708c5.523 0 10-4.477 10-10s-4.477-10-10-10h-33.708c-5.523 0-10 4.477-10 10v80c0 5.523 4.477 10 10 10h33.708c5.523 0 10-4.478 10-10z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "XMLID_1327_",
              d: "m335.89 206.042h-23.238c-5.523 0-10 4.477-10 10v80c0 5.523 4.477 10 10 10h27.296c17.388 0 31.534-14.188 31.534-31.628 0-9.903-4.593-18.75-11.756-24.536 2.888-4.446 4.573-9.742 4.573-15.428-.001-15.665-12.745-28.408-28.409-28.408zm0 20c4.636 0 8.408 3.772 8.408 8.408s-3.772 8.408-8.408 8.408c-1.703 0-13.238.021-13.238.021v-16.838h13.238zm4.058 60h-17.296v-23.144c1.605-.006 17.296-.018 17.296-.018 6.36 0 11.534 5.174 11.534 11.534-.001 6.411-5.174 11.628-11.534 11.628z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "XMLID_1332_",
              d: "m209.921 434.042c5.523 0 10-4.477 10-10v-80c0-5.523-4.477-10-10-10h-17.1c-5.523 0-10 4.477-10 10s4.477 10 10 10h7.1v70c0 5.522 4.477 10 10 10z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "XMLID_1336_",
              d: "m298.771 424.015c-.015 5.523 4.45 10.012 9.973 10.027h.027c5.51 0 9.985-4.46 10-9.973l.037-13.638h.371c5.523 0 10-4.477 10-10s-4.477-10-10-10h-.317l.11-40.817c0-.286-.011-.572-.035-.857-.565-6.781-4.67-12.321-10.457-14.113-5.756-1.781-11.852.412-16.302 5.872-.336.413-.639.852-.906 1.313l-30.988 53.598c-1.789 3.094-1.791 6.907-.004 10.003 1.786 3.095 5.088 5.002 8.662 5.002h29.866zm-12.497-33.585 12.646-21.874-.059 21.874z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "XMLID_1337_",
              d: "m256 472c-2.63 0-5.21 1.07-7.07 2.93s-2.93 4.44-2.93 7.07 1.07 5.21 2.93 7.07 4.44 2.93 7.07 2.93 5.21-1.07 7.07-2.93 2.93-4.44 2.93-7.07-1.07-5.21-2.93-7.07-4.44-2.93-7.07-2.93z",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }